import axios from "axios";
import qs from "qs";
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";
axios.defaults.transformRequest = (data) => qs.stringify(data);
let ali_url = "https://www.fangpinyouxuan.com";
let work_url = "http://192.168.8.6:8083";

let url = process.env.NODE_ENV === "production" ? ali_url : ali_url;
// let url = process.env.NODE_ENV === "production" ? work_url : work_url;
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: url,
  // 超时
  timeout: 10000,
});

const switchUrl = (config) => {
  let { baseURL, url } = config;
  let changeBaseURL = "";
  let interfaceName = url.split("/")[0];
  if (interfaceName === "information") {
    changeBaseURL = "http://192.168.8.12:8083";
  }
  if (interfaceName === "building") {
    changeBaseURL = "http://192.168.8.12:8084";
  }
  return changeBaseURL;
};

// request拦截器
service.interceptors.request.use(
  (config) => {
    // if (process.env.NODE_ENV !== "production") {
    //   let { url } = config;
    //   config.baseURL = switchUrl(config);
    //   config.url = config.url
    //     .split("/")
    //     .splice(1, url.length - 1)
    //     .join("/");
    // }
    return config;
  },
  (error) => {
    console.log(error);
    Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (res) => {
    const code = res.data.statusCode;
    const data = res.data;
    if (code === 401) {
      return Promise.reject("无权限");
    } else if (code !== 201) {
      console.log(data);
      return Promise.reject(data);
    } else {
      return res.data;
    }
  },
  (error) => {
    console.log("err" + error);
    return Promise.reject(error);
  }
);

export default service;
